import { gql } from "@apollo/client";

export const SESSION_QUERY = gql`
  query Session($fingerprintId: String!, $lastEventTimestamp: String!) {
    session(
      fingerprintId: $fingerprintId
      lastEventTimestamp: $lastEventTimestamp
    ) {
      id
      count
      isNew
    }
  }
`;
